// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__k36yV","tabsBox":"styles_tabsBox__3UWAe","createButton":"styles_createButton__2hzp9"};